import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { PageType } from 'src/app/analytics/newrelic/enums/PageType';
import { ClevertapService } from '../../analytics/clevertap/service/clevertap.service';
import { TabService } from './tabs/tab.service';
import { ClevertapEvent } from 'src/app/analytics/clevertap/enum/clevertap.eventType';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  searchItemPosition: string | undefined = undefined;
  private previouscreen: string | undefined;
  private currentscreen: string | undefined;
  private searchLink = '';
  private history: string[] = [];
  private navigation$ = new BehaviorSubject({
    previousScreen: undefined,
    currentscreen: undefined,
    tabId: undefined,
    tabName: undefined,
    type: undefined,
    tabs: undefined,
  });
  get currentScreen(): string {
    return this.currentscreen || '';
  }

  set currentScreen(value: string) {
    this.currentscreen = value;
  }

  set previousScreen(value: string) {
    this.previouscreen = value;
  }

  get previousScreen(): string {
    return this.previouscreen || '';
  }

  constructor(
    private router: Router,
    private tabService: TabService,
    private clevertapService: ClevertapService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) {
    this.navigation$.asObservable().subscribe((result) => {
      if (result.type === 'tab') {
        this.tabService.currentTabId = result.tabId || '';
        this.tabService.currentTabName = result.tabName || '';
      } else {
        this.setCurrentScreen(result.currentscreen || '');
      }
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history?.push(event.urlAfterRedirects);
        const pageId =
          this.activatedRoute?.snapshot?.firstChild?.data?.pageID ||
          this.activatedRoute?.firstChild?.snapshot?.firstChild?.data?.pageID;
        this.setCurrentScreen(pageId);
        this.clevertapService.addEvent(ClevertapEvent.PAGE_VIEW, {
          previousPage:
            typeof this.previousScreen === 'string'
              ? this.previousScreen
              : this.previousScreen?.[this.translate.currentLang] || undefined,

          currentPage:
            typeof this.currentScreen === 'string'
              ? this.currentScreen
              : this.currentScreen?.[this.translate.currentLang] || undefined,
        });
      }
    });
  }

  set searchlink(value: string) {
    this.searchLink = value;
  }

  get searchlink(): string {
    return this.searchLink;
  }

  setCurrentScreen(currentScreen: string): void {
    this.previouscreen = this.currentscreen;
    if (currentScreen === PageType.Browse) {
      this.currentscreen = this.tabService.currentTabName;
    } else {
      this.currentscreen = currentScreen;
    }
  }
}
